module.exports = __webpack_public_path__ + "static/media/toki.afe478b9.mp4";